/** @jsxImportSource @emotion/react */
"use client";
import type { MouseEventHandler } from "react";
import { useCallback } from "react";

/** Avoid circular dependency */
import type { Game } from "../../../../../../games/src/games/categories";
import { useShare } from "../../../../../../games/src/games/categories";
import { IconButton } from "../../_core/IconButton/IconButton.emotion";
import { ShareIcon } from "../../icons/Icon/GeneralIcons";

export const CategoriesGameShareIconButton = ({ game }: { game: Game }) => {
  const share = useShare({ game, isSendNativeMessage: false });

  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      share();
    },
    [share],
  );

  return (
    <IconButton
      icon={<ShareIcon />}
      onClick={onClick}
      size="s"
      variant="transparentWhite"
    />
  );
};
